import {Box, Button, Paper, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {getCompanyProducts, saveCompanyProducts} from "../../../services/CompanyService";
import {useMessageContext} from "../../../contexts/MessageContext";

const CompanyProductTab = ({company, setLoader}) => {

  const {notificationHandler} = useMessageContext();

  const [companyProducts, setCompanyProducts] = useState();

  const [reload, setReload] = useState(false);

  useEffect(() => {
    setLoader(true);
    getCompanyProducts(company.id)
        .then(res => {
          setCompanyProducts(res.data);
        }).then(() => setLoader(false))
  }, [reload]);

  const updateCustomField1 = (customField1) => {
    setCompanyProducts(prv => {
      return {...prv, customField1}
    })
  }

  const updateCustomField2 = (customField2) => {
    setCompanyProducts(prv => {
      return {...prv, customField2}
    })
  }

  const updateCustomField3 = (customField3) => {
    setCompanyProducts(prv => {
      return {...prv, customField3}
    })
  }

  const updateProductOffering1 = (productOffering1) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering1}
    })
  }

  const updateProductOffering2 = (productOffering2) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering2}
    })
  }

  const updateProductOffering3 = (productOffering3) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering3}
    })
  }

  return (
      <Paper component={"form"}
             onSubmit={(event => {
               event.preventDefault();
               setLoader(true);
               companyProducts.companyId = company.id;
               saveCompanyProducts(companyProducts)
                   .then(() => setReload(prv => !prv))
                   .then(() => notificationHandler.success('Company Products Saved'))
                   .finally(() => setLoader(false))
             })}
             sx={{margin: "48px", padding: "24px"}} elevation={2}>

        {companyProducts && <Box sx={{display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "center"}}>

          <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>Custom Fields</Typography>

          <TextField
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              sx={{mt: "16px"}}
              label="Custom Field 1"
              placeholder="Enter custom field 1 information"
              value={companyProducts.customField1 || ''}
              onChange={(event) => {
                updateCustomField1(event.target.value);
              }}
          />

          <TextField
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              sx={{mt: "16px"}}
              label="Custom Field 2"
              placeholder="Enter custom field 2 information"
              value={companyProducts.customField2 || ''}
              onChange={(event) => {
                updateCustomField2(event.target.value);
              }}
          />

          <TextField
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              sx={{mt: "16px"}}
              label="Custom Field 3"
              placeholder="Enter custom field 3 information"
              value={companyProducts.customField3 || ''}
              onChange={(event) => {
                updateCustomField3(event.target.value);
              }}
          />

          <Typography variant="h6" sx={{mt: 4, mb: 2, fontWeight: 600}}>Product Offerings</Typography>

          <TextField
              fullWidth
              multiline
              minRows={3}
              maxRows={6}
              sx={{mt: "16px"}}
              label="Product Offering 1"
              placeholder="Describe your first product offering"
              value={companyProducts.productOffering1 || ''}
              onChange={(event) => {
                updateProductOffering1(event.target.value);
              }}
          />

          <TextField
              fullWidth
              multiline
              minRows={3}
              maxRows={6}
              sx={{mt: "16px"}}
              label="Product Offering 2"
              placeholder="Describe your second product offering"
              value={companyProducts.productOffering2 || ''}
              onChange={(event) => {
                updateProductOffering2(event.target.value);
              }}
          />

          <TextField
              fullWidth
              multiline
              minRows={3}
              maxRows={6}
              sx={{mt: "16px"}}
              label="Product Offering 3"
              placeholder="Describe your third product offering"
              value={companyProducts.productOffering3 || ''}
              onChange={(event) => {
                updateProductOffering3(event.target.value);
              }}
          />

          <Box sx={{mt: "48px", display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button type="submit" variant={"contained"}>Save</Button>
          </Box>

        </Box>}
      </Paper>
  );
};

export default CompanyProductTab;
